import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import StartConversation from './startConversation';
import FacilityCommunicationBreadcrumb from './facilityCommunicationBreadcrumb';

class SearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <FacilityCommunicationBreadcrumb />
                <div className="row" style={{ padding: '12px' }}>
                    <div className="col-md-3">
                        <TextField
                            label="Current Grid Search"
                            variant="outlined"
                            id="reset-form"
                            InputLabelProps={{
                                shrink: true
                            }}
                            type="string"
                            margin="dense"
                            onChange={this.props.onFilterTextChange}
                        />
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-primary button-info-grid" onClick={() => this.props.clearFilter()}>
                            <i className="fa fa-times" aria-hidden="true"></i> Clear Filter
                        </button>
                    </div>
                    <div className="col-md-7" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div>
                            <StartConversation context={this.props.context} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchMenu;
